<template>
    <div v-if="$store.state.openid != ''">
        <top-bar>
            <div class="title">实名认证</div>
        </top-bar>
        <van-form @submit="onSubmit">
            <van-field
                v-model="code"
                name="companyId"
                label="客户认证码"
                placeholder="填写客户认证码"
                @blur="checkCode"
                :rules="[{ required: true, message: '填写客户认证码' }]"
            />
            <div class="company" v-if="company.companyName">
                <span >公司名称：</span>
                <span >{{company.companyName}}</span>
            </div>
            <van-loading v-if="loading" type="spinner" color="#1989fa" />
            <van-field
                v-model="idCard"
                name="idcard"
                label="身份证号"
                placeholder="填写身份证号"
                :rules="[{ required: true, message: '填写身份证号' }]"
            />
            <van-field
                v-model="phone"
                name="phone"
                label="手机号"
                placeholder="填写手机号"
                maxlength="11"
                @blur="checkPhone"
                :rules="[{ required: true, message: '填写手机号' }]"
            />
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">确认</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import Vue from "vue";
import TopBar from "@/components/Top";
import { Form,Field,Toast } from "vant";
import { validateIdCard,isPoneAvailable } from '@/common/common'
import { init,GetQueryString } from '@/utils/getOpenId'
import { httpAction,httpActionGetHeader,getOpenId } from '@/http/salary'

Vue.use(Form);
Vue.use(Field);
Vue.use(Toast);

export default {
    data() {
        return {
            code: "",
            idCard: "",
            openid:'',
            phone:'',
            company:{
                companyName: false
            },
            loading:false
        };
    },
    components: {
        TopBar,
    },
    mounted(){
        
    },
    created() {
        if(this.$store.state.openid == ''){
            let openid = this.$route.query.openId
            this.$store.dispatch('SAVEUSERACTION',openid)
        }   
        // if(this.$store.state.openid == ''){
        //     this.$cookies.set('history','Certification',60 * 60 * 1)
        //     let url = encodeURI('http://testwx-platform.engma.net/#/Certification')
        //     window.location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx815dbde2374f3068&response_type=code&scope=snsapi_base&redirect_uri=${url}&state=Certification#wechat_redirect`
        // }else{
        //     this.openid =  this.init()
        // }
    },
    computed:{
        history(){
            return this.$cookies.get('history')
        }
    },
    methods: {
        async init(){
            let _this = this
            const res = await getOpenId("/wxAuth/codeToOpenid",{code:GetQueryString('code')});
            if(res.msg == 'success'){
                _this.$store.dispatch('SAVEUSERACTION',res.data)
                return res.data
            }
        },
        onSubmit(values) {
            let info = {
                companyId: this.company.id,
                idcard: values.idcard,
                phone:values.phone,
                unionId:''
            }
            httpAction('post','front/realname/realAuth',info).then((res) => {
                if(res.msg == 'success'){
                    Toast.success('实名认证成功')
                    this.$router.push(`./${this.$cookies.get('history')}`)
                }else{
                    Toast.fail('实名认证失败，请联系客服后再试')
                }
            })
        },
        checkId(){
            if(this.idCard){
                if(!validateIdCard(this.idCard)){
                    Toast.fail('身份证号错误')
                }
            }
        },
        checkPhone(){
            if(this.phone){
                if(this.phone.length == 11){
                    if(!isPoneAvailable(this.phone)){
                        Toast.fail('手机号错误')
                        this.phone = ''
                    }
                }else{
                    Toast.fail('手机号不完整')
                }
            }
        },
        checkCode(){
            this.loading = true
            this.company.companyName = false 
            if(this.code){
                httpActionGetHeader('/front/realname/companyName','form',{ inviteCode: this.code}).then((res) => {
                    if(res.msg == 'success'){
                        this.company = res
                    }else{
                        this.code = ''
                        Toast.fail(res.msg)
                    }
                    this.loading = false
                })
            }else{
                Toast.fail('请输入正确的认证码')
            }
        }
    },
};
</script>

<style lang="less" scoped>
.title {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(0, 140, 255);
    font-weight: 700;
    font-size: 16px;
    letter-spacing: 8px;
}
.company{
    padding: 20px;
    span{
        margin: 0 10px;
    }
}
</style>
